import { Vector3 } from "@babylonjs/core";

function lerp(start, end, amt) {
  return (1 - amt) * start + amt * end;
}

function midPointBetween(p1, p2) {
  return {
    x: p1.x + (p2.x - p1.x) / 2,
    y: p1.y + (p2.y - p1.y) / 2,
  };
}

function vecToLocal(vector, el) {
  const m = el.getWorldMatrix();
  return Vector3.TransformCoordinates(vector, m);
}

function isValueInRange(range, val) {
  if (range[0] > range[1]) {
    return val >= range[0] || val <= range[1];
  } else {
    return val >= range[0] && val <= range[1];
  }
}

function preloadVideo(url) {
  var req = new XMLHttpRequest();
  req.open("GET", url, true);
  req.responseType = "blob";

  //   req.onload = function() {
  //     // Onload is triggered even on 404
  //     // so we need to check the status code
  //     if (this.status === 200) {
  //       console.log(this.response);
  //       //   var vid = URL.createObjectURL(videoBlob); // IE10+
  //       // Video is now downloaded
  //       // and we can set it as source on the video element
  //       //   video.src = vid;
  //     }
  //   };
  req.onerror = function() {
    // Error
    console.log("error preloading video ", url);
  };

  req.send();
}

export { lerp, midPointBetween, vecToLocal, isValueInRange, preloadVideo };
